// @ts-nocheck
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrders";

replaceInChain(chain, PopulateApiParameter, props => {
    props.apiParameter = { ...props.parameter, expand: ["orderLines"] };
});
